import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { Constants } from '../constants/constants';
import { AdminRoleService } from '../service/admin-role.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { EnvService } from '../service/env.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-trip-events',
  templateUrl: './trip-events.component.html',
  styleUrls: ['./trip-events.component.scss']
})
export class TripEventsComponent implements OnInit {

  accountCategory: string;
  accountType: string;
  trip = null;
  tripEvents = null;
  pageIndex = 0;
  pageSize = 4;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService,
    private adminRoleService: AdminRoleService, private env: EnvService) {
  }

  ngOnInit(): void {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.trip = this.utilService.selectedTrip;
    this.getTripEvents();
  }

  getTripEvents() {
    this.utilService.showSpinner();
    this.apiService.getTripEvents(this.trip, this.pageIndex, this.pageSize).then((data) => {
      this.utilService.hideSpinner();
      this.tripEvents = data;
      console.log("trip events received ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getTripEvents();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  nextPage(): void {
    this.pageIndex++;
    this.getTripEvents();
  }

  prevPage(): void {
    if (this.pageIndex > 1) {
      this.pageIndex--;
      this.getTripEvents();
    }
  }

}
